"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toProgramMessage = exports.toControlChangeMessage = exports.toNoteMessage = void 0;
const toNoteMessage = (m) => (Object.assign(Object.assign({}, m), { note: m.data1, velocity: m.data2 }));
exports.toNoteMessage = toNoteMessage;
const toControlChangeMessage = (m) => (Object.assign(Object.assign({}, m), { control: m.data1, value: m.data2 }));
exports.toControlChangeMessage = toControlChangeMessage;
const toProgramMessage = (m) => (Object.assign(Object.assign({}, m), { program: m.data1, value: m.data2 }));
exports.toProgramMessage = toProgramMessage;
